import { render, staticRenderFns } from "./set-keyword-modal.vue?vue&type=template&id=2ceac72d&scoped=true&"
import script from "./set-keyword-modal.vue?vue&type=script&lang=js&"
export * from "./set-keyword-modal.vue?vue&type=script&lang=js&"
import style0 from "./set-keyword-modal.vue?vue&type=style&index=0&id=2ceac72d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceac72d",
  null
  
)

export default component.exports